import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Schedule } from '../../models/schedule';

const getScheduleSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Schedule>) => memoize((
        specialtyId: Undefinable<number>
    ) => memoize((
        date: Undefinable<string>
    ) => memoize((
        time: Undefinable<string>
    ) => Object
        .keys(byId)
        .map(x => byId[x]!)
        .find(x =>
            x.date === date &&
            x.time === time &&
            (!specialtyId || x.specialtyIds.includes(specialtyId))
        )
    )))
);

const getTimesSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Schedule>) => memoize((
        providerId: Undefinable<number>
    ) => memoize((
        date: string
    ) => memoize((
        facilityId: Undefinable<number>
    ) => memoize((
        specialtyId: Undefinable<number>
    ) => memoize((
        appointmentDate: Undefinable<string>
    ) => memoize((
        appointmentTime: Undefinable<string>
    ) => Array.from(new Set(Object
        .keys(byId)
        .filter(x =>
            (!providerId || byId[x]!.providerId === providerId) &&
            byId[x]!.date === date &&
            (!facilityId || byId[x]!.facilityId === facilityId) &&
            (!specialtyId || byId[x]!.specialtyIds.includes(specialtyId)) &&
            (!appointmentDate || byId[x]!.date === appointmentDate) &&
            (!appointmentTime || byId[x]!.time === appointmentTime) &&
            !byId[x]!.limited
        )
        .map(x => byId[x]!.time)
        .sort((a, b) => a > b ? 1 : -1)
    ))))))))
);

export const selectors = {
    getLoading: (
        state: State,
        payload: {
            providerId?: number,
            date: Undefinable<string>
        }
    ): boolean => state.loading[[payload.providerId || '', payload.date || ''].join('-')] || false,
    getSchedule: (
        state: State,
        payload: {
            providerId?: number,
            specialtyId?: number,
            date: Undefinable<string>,
            time: Undefinable<string>
        }
    ): Undefinable<Schedule> => payload.providerId ?
            state.byId[[payload.providerId, payload.date || '', payload.time || ''].join('---')] :
            getScheduleSelector(state)(payload.specialtyId)(payload.date)(payload.time),
    getScheduleHash: (
        state: State
    ): Dictionary<Schedule> => state.byId,
    getTimes: (
        state: State,
        payload: {
            providerId?: number,
            date: string,
            facilityId?: number,
            specialtyId?: number,
            appointmentDate?: string,
            appointmentTime?: string
        }
    ): string[] => getTimesSelector(state)(payload.providerId)(payload.date)(payload.facilityId)(payload.specialtyId)(payload.appointmentDate)(payload.appointmentTime),
};
